import React, { useMemo } from 'react';
import { Banner } from 'components/Banner';
import { EBundlesInternalViewModel, EConfigs } from 'utils/enums';
import { getTemplateProperty } from '../utils';
import { useStoreState } from 'state/hooks/store.state.hook';

export interface IBannerWrapperProps {
  noOffers: boolean;
  bundlesInternalViewModel: EBundlesInternalViewModel;
  bannerImage?: string;
  playerLevelImg?: string;
}

export const BannerWrapper: React.FC<IBannerWrapperProps> = ({
  noOffers,
  bundlesInternalViewModel,
  bannerImage,
  playerLevelImg,
}) => {
  const { storeTheme } = useStoreState();

  const bannerImageSrc = useMemo(() => {
    if (noOffers) {
      return '';
    }

    if (bannerImage)
      return bannerImage || storeTheme?.storeScreen?.defaultBanner;

    if (
      playerLevelImg &&
      [
        EBundlesInternalViewModel.CASHMAN_CASINO,
        EBundlesInternalViewModel.PIPA,
        EBundlesInternalViewModel.LIGHTNING_LINK_CASINO,
        EBundlesInternalViewModel.MIGHTY_FU_CASINO,
      ].includes(bundlesInternalViewModel)
    ) {
      return playerLevelImg;
    }

    return '';
  }, [
    noOffers,
    bundlesInternalViewModel,
    playerLevelImg,
    bannerImage,
    storeTheme?.storeScreen?.defaultBanner,
  ]);

  if (!bannerImageSrc) return <></>;

  return (
    <Banner
      imageSrc={bannerImageSrc}
      maxWidth={getTemplateProperty(
        EConfigs.bannerMaxWidth,
        bundlesInternalViewModel,
      )}
      minWidth={getTemplateProperty(
        EConfigs.bannerMinWidth,
        bundlesInternalViewModel,
      )}
      mx={getTemplateProperty(EConfigs.bannerMX, bundlesInternalViewModel)}
    />
  );
};
